(function() {
    var setValue = function($select, val, title) {
        $('select', $select).val(val);
        $('.sqq-select-title-text', $select).text(title);
        $('.sqq-select-list', $select).addClass('d-none');
        toggleList(true);

        // Redirect to sort
        var url = document.location.origin + document.location.pathname + '?comments_sort=' + val + '#comments';
        document.location = url;
    };

    var toggleList = function($select, val) {
        $('.sqq-select-list', $select).toggleClass('d-none', val);
    };

    $(document).on('click', '.sqq-select-title', function() {
        var $select = $(this).closest('.sqq-select');
        toggleList($select);
    });

    $(document).on('click', '.sqq-select-list-option', function() {
        var $select = $(this).closest('.sqq-select');
        var val = $(this).data('value');
        var title = $(this).text();
        setValue($select, val, title);
    });
})();
